import Vue from 'vue'
import { AlertsAPI, SattelliteAPI } from '@/api'

const state = {
   alerts: [],
   images: [],
   isSearching: false,
   errors: [],
   isValuePickerSelected: false,
   currentValue: ''
}

const getters = {
   alerts: state => state.alerts,
   images: state => state.images,
   selectedImage: state => {
      return state.images.find(image => image.isSelected)
   },
   selectedAlert: state => {
      return state.alerts.find(alert => alert.isSelected)
   },
   isSearching: state => state.isSearching,
   errors: state => state.errors,
   isValuePickerSelected: state => state.isValuePickerSelected,
   isValuePickerEnabled: (state, getters) => state.isValuePickerSelected && getters.selectedImage,
   currentValue: state => state.currentValue
}

const actions = {
   search({ commit }, dateRange) {
      commit('searching', true)

      Promise
         .all([
            SattelliteAPI.get(dateRange),
            AlertsAPI.get(dateRange)
         ])
         .then(([images, alerts]) => {
            commit('alerts', alerts)
            commit('images', images)
         })
         .catch(e => {
            commit('error', { type: 'apiError', error: e })
         })
         .finally(() => {
            commit('searching', false)
         })
   }
}

const mutations = {
   alerts(state, alerts) {
      state.alerts = alerts
   },
   images(state, images) {
      state.images = images
   },
   searching(state, searching) {
      state.isSearching = searching
   },
   highlightAlert(state, { index, isHiglighted }) {
      Vue.set(state.alerts[index], 'isHiglighted', isHiglighted)
   },
   selectAlert(state, { index, isSelected }) {
      state.alerts.forEach((_, alertIndex) => {
         Vue.set(state.alerts[alertIndex], 'isSelected', alertIndex == index && isSelected)
      });
   },
   selectImage(state, { index, isSelected }) {
      state.images.forEach((_, imageIndex) => {
         Vue.set(state.images[imageIndex], 'isSelected', imageIndex == index && isSelected)
      });
   },
   loading(state, { index, isLoading }) {
      Vue.set(state.alerts[index], 'isLoading', isLoading)
   },
   selectValuePicker(state, isSelected) {
      state.isValuePickerSelected = isSelected
   },
   error(state, error) {
      state.errors.push({
         timestamp: new Date()
            .valueOf(),
         ...error
      })
   },
   setCurrentValue(state, value) {
      state.currentValue = value
   }
}

export default {
   state,
   getters,
   actions,
   mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/search.js